import React, { memo } from 'react'
import { required, useTranslate } from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { useQuery } from 'react-query'
import {
  BILLING,
  LIQUIDATION,
  PRICE,
} from 'src/components/pages/sales/business-rule/helper/const'

export const GetTrainSegmentFields = memo(({ record, selectedRuleType }) => {
  const translate = useTranslate()
  const marketing_carrier = useQuery(
    'ext-train-marketing-carrier',
    () => businessRuleServices.getMarketingCarrierTrain({ limit: 999 })
  )

  const supplier = useQuery('ext-train-supplier', businessRuleServices.getTrainSupplier)

  return (
    <Grid container spacing={3}>
      <EditInputsWrap label={translate('ra.field.supplier')} required lg={4} md={4} xs={4}>
        {supplier?.isLoading ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='train_segment.supplier'
            options={supplier?.data || []}
            label=''
            optionsText={['long_name']}
            optionValue='short_name'
            size='small'
            showAllOption
            showSearch
            multiple
            defaultValue={record ? record?.train_segment?.supplier : undefined}
            validate={[required()]}
          />
        )}
      </EditInputsWrap>
      {(selectedRuleType === LIQUIDATION || selectedRuleType === PRICE || selectedRuleType === BILLING) && (
        <EditInputsWrap label={translate('ra.field.marketing_carrier')} lg={8} md={8} xs={8}>
          {marketing_carrier?.isLoading ? (
            <Skeleton variant='rectangular' width={'100%'} height={40} />
          ) : (
            <SelectInput
              source='train_segment.marketing_carrier'
              options={marketing_carrier?.data || []}
              limitOptions={false}
              label=''
              optionsText={['short_name','long_name']}
              optionValue='short_name'
              size='small'
              showAllOption
              showSearch
              multiple
              defaultValue={record ? record?.train_segment?.marketing_carrier : undefined}
              validate={[required()]}
            />
          )}
        </EditInputsWrap>
      )}
    </Grid>
  )
})
